export { default } from './useEventSearch';
